(function () {
  const DRAG_THRESHOLD = 10;

  function initGalleryNavigation(card, slides) {
    const url = card.dataset.productUrl;
    if (!url) return;

    const isSwipeable = slides.children.length > 1;
    let pointerStart = null;
    let scrollStart = 0;
    let dragged = false;
    let activePointerId = null;
    let isMousePointer = false;

    const preventImageDrag = (event) => {
      event.preventDefault();
    };

    slides.addEventListener('dragstart', preventImageDrag);

    slides.querySelectorAll('img').forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', preventImageDrag);
    });

    const resetPointer = () => {
      if (activePointerId !== null && slides.hasPointerCapture(activePointerId)) {
        slides.releasePointerCapture(activePointerId);
      }
      pointerStart = null;
      activePointerId = null;
      isMousePointer = false;
    };

    slides.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      pointerStart = { x: event.clientX, y: event.clientY };
      scrollStart = slides.scrollLeft;
      dragged = false;
      activePointerId = event.pointerId;
      isMousePointer = event.pointerType === 'mouse';
      if (isSwipeable && isMousePointer) {
        slides.setPointerCapture(activePointerId);
      }
    });

    slides.addEventListener('pointermove', (event) => {
      if (!pointerStart || event.pointerId !== activePointerId) return;

      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;

      if (!dragged && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
        dragged = true;
      }

      if (dragged && isSwipeable && isMousePointer) {
        event.preventDefault();
        slides.scrollLeft = scrollStart - dx;
      }
    });

    slides.addEventListener('pointerup', (event) => {
      if (event.pointerId !== activePointerId) return;
      resetPointer();
    });

    slides.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== activePointerId) return;
      resetPointer();
    });

    slides.addEventListener('click', (event) => {
      if (dragged) {
        event.preventDefault();
        event.stopPropagation();
        dragged = false;
        return;
      }
      window.location.assign(url);
    });
  }

  function updateProgress(slides, bar) {
    if (!slides || !bar) return;
    const count = slides.children.length;
    if (count <= 1) {
      bar.style.width = '100%';
      bar.style.transform = 'translateX(0)';
      return;
    }
    const slideWidth = slides.clientWidth || 1;
    const index = Math.round(slides.scrollLeft / slideWidth);
    const segment = 100 / count;
    bar.style.width = segment + '%';
    bar.style.transform = 'translateX(' + index * 100 + '%)';
  }

  function updateArrowState(slides, prev, next) {
    if (!slides || (!prev && !next)) return;
    const maxScroll = slides.scrollWidth - slides.clientWidth;
    const left = slides.scrollLeft;
    if (prev) prev.disabled = left <= 1;
    if (next) next.disabled = left >= maxScroll - 1;
  }

  function initGalleryArrows(card, slides) {
    const prev = card.querySelector('[data-plp-card-prev]');
    const next = card.querySelector('[data-plp-card-next]');
    if (!prev && !next) return { prev: null, next: null };

    const stopNav = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    const scrollBySlide = (direction) => {
      const slideWidth = slides.clientWidth || 1;
      slides.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
    };

    [prev, next].forEach((button) => {
      if (!button) return;
      button.addEventListener('pointerdown', stopNav);
      button.addEventListener('click', stopNav);
    });

    prev?.addEventListener('click', () => scrollBySlide(-1));
    next?.addEventListener('click', () => scrollBySlide(1));

    return { prev, next };
  }

  function initCard(card) {
    const slides = card.querySelector('[data-plp-card-slides]');
    const bar = card.querySelector('[data-plp-card-progress]');
    if (!slides) return;

    const { prev, next } = initGalleryArrows(card, slides);

    const onScroll = () => {
      updateProgress(slides, bar);
      updateArrowState(slides, prev, next);
    };

    slides.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    initGalleryNavigation(card, slides);
  }

  function init(root) {
    root.querySelectorAll('[data-plp-card]').forEach(initCard);
  }

  function initAll() {
    document.querySelectorAll('[data-plp-products]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-plp-products]');
    if (section) init(section);
  });
})();
